import { Trans } from "@lingui/macro"
import { Button } from "@silversea-ssc/ui-components-react"
import React, { useCallback } from "react"

import clsx from "clsx"
import { useECommerceMachine } from "../../../app-core/_common/machines/machines-context"
import { useReceiptReadModel } from "../../../app-core/v3/_common/machines/receipt-machine"
import Receipt from "../../Receipt/Receipt"
import styles from "./ExpandableReceipt.module.scss"

type Props = {
    className?: string
}

const ExpandableReceipt: React.FC<Props> = ({ className }) => {
    const [state] = useECommerceMachine()
    const [stateRC] = useReceiptReadModel(state)
    const [isExpanded, setIsExpanded] = React.useState(false)
    const toggleExpand = useCallback(() => setIsExpanded((status) => !status), [])

    const price = stateRC.context.receipt?.price
    if (!price) return null

    return (
        <footer className={className}>
            <Button
                renderAs="button"
                variant="text"
                full
                iconName={isExpanded ? "chevron-up" : "chevron-down"}
                onClick={toggleExpand}
                dataContentPiece={isExpanded ? "collapse-receipt" : "expand-receipt"}
            >
                {isExpanded ? <Trans>Collapse all details</Trans> : <Trans>Expand all details</Trans>}
            </Button>

            <div
                className={clsx(styles.recepit, {
                    [styles.expanded]: isExpanded,
                })}
            >
                <div className={styles.recepitContent}>
                    <Receipt withInclusions />
                </div>
            </div>
        </footer>
    )
}

export default ExpandableReceipt
